export const ROOT = '/';
export const WELCOME = '/';
export const SIGNIN = '/sign-in';
export const VERIFY = '/sign-in/:type/:slug';
export const DASHBOARD = '/dashboard';
export const RECOVERY = '/sign-in/recovery';
export const PROFILE = '/profile';

export const BALANCE = '/balance';
export const BALANCE_ADD_FUNDS = '/balance/addfunds';

export const RESERVATIONS = '/reservations';
export const RESERVATION_DETAIL = '/reservations/:id';

export const RESERVATION_NEW = '/new-reservations';
export const PAYMENT_STATE = '/payment/:result';

export const ADMIN = '/administration';
export const ADMIN_USERS = '/administration/users';
export const PASSWORD_COUPON = '/print/username/:username/password/:password';
export const CHANGE_PASSWORD = '/profile/password/change/required';
export const CHANGE_PASSWORD_PREFILLED = '/profile/password/change/required/:oldPassword';


// WEBPACK FOOTER //
// ./src/routes.js